import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HomeBanner from './components/banner/HomeBanner';
import AllCategories from './components/categories/AllCategories';
import SubCategoriesWrapper from "./components/categories/SubCategoriesWrapper";
import { fetchCheckAuth } from "./features/auth/authSlice";
import { fetchGetCart } from './features/cart/cartSlice';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/common/Layout';
import Home from './pages/Home';
import ProductPage from './pages/ProductPage';

function App() {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    useEffect(() => {
        dispatch(fetchCheckAuth());
    }, [dispatch]);
    useEffect(() => {
        if (user) dispatch(fetchGetCart());
    }, [user]);

    return (
        <BrowserRouter>
        <Routes>
            <Route path="/" element={<Layout/>}>
            <Route index element={<Home/>}/>
            <Route path="product/:pId" element={<ProductPage/>}/>
            </Route>
        </Routes>
        </BrowserRouter>
    );
}

export default App;